import { isArray } from 'lodash'
import {
  STORE_EDUCATION_DEGREES,
  STORE_PERSONAL_INFO,
  STORE_TEACHING_COURSES,
  STORE_TEACHING_PRICE,
  UPDATE_PERSONAL_INFO,
  STORE_WORK_EXPERIENCES,
  STORE_CERTIFICATES,
  STORE_PROFILE_PICTURE,
  STORE_TEACHER_ABOUT,
  STORE_INTRO_VIDEO,
  STORE_WORK_TIME,
  STORE_DOCUMENTS,
  STORE_TRACKING,
  STORE_LANGUAGES,
  STORE_STEP_STATUS,
  STORE_START_TEACHING_PRICE_CHART,
  STORE_TAGLINE,
  STORE_INTRODUCTION, STORE_START_TEACHING_STATUS,
  STORE_JOIN_US
} from '../mutation-types'

export default {
  [STORE_PERSONAL_INFO] (state, payload) {
    state.personalInfoFetchedData = payload
    state.personalInfo = {
      first_name: payload?.first_name,
      last_name: payload?.last_name,
      gender: payload?.gender,
      birthdate: payload?.birthdate.value,
      born_zn_country_id: payload?.born_zn_country_id,
      live_zn_country_id: payload?.live_zn_country_id,
      mobile_zn_country_id: payload?.mobile?.zn_country?.id,
      mobile_number: payload?.mobile?.number,
      timezone: payload?.timezone
    }
  },
  [UPDATE_PERSONAL_INFO] (state, payload) {
    if (isArray(payload.value)) {
      state.personalInfo[payload.key] = []
      state.personalInfo[payload.key] = [...payload.value]
    } else {
      state.personalInfo[payload.key] = payload.value
    }
  },
  [STORE_STEP_STATUS] (state, payload) {
    state.stepStatus = payload
  },
  [STORE_LANGUAGES] (state, payload) {
    state.languages = payload
  },
  [STORE_TEACHING_COURSES] (state, payload) {
    state.teachingCourses = payload
  },
  [STORE_TEACHING_PRICE] (state, payload) {
    state.teachingPriceFetchedData = payload
  },
  [STORE_EDUCATION_DEGREES] (state, payload) {
    state.educationDegrees = payload
  },
  [STORE_WORK_EXPERIENCES] (state, payload) {
    state.workExperiences = payload
  },
  [STORE_CERTIFICATES] (state, payload) {
    state.certificates = payload
  },
  [STORE_PROFILE_PICTURE] (state, payload) {
    state.profilePicture = payload
  },
  [STORE_TEACHER_ABOUT] (state, payload) {
    state.teacherAbout = payload
  },
  [STORE_INTRO_VIDEO] (state, payload) {
    state.introVideo = payload
  },
  [STORE_WORK_TIME] (state, payload) {
    state.workTime = payload
  },
  [STORE_DOCUMENTS] (state, payload) {
    state.documents = payload
  },
  [STORE_TRACKING] (state, payload) {
    state.tracking = payload
  },
  [STORE_START_TEACHING_PRICE_CHART] (state, payload) {
    state.priceChart = payload
  },
  [STORE_TAGLINE] (state, payload) {
    state.tagline = payload
  },
  [STORE_INTRODUCTION] (state, payload) {
    state.introduction = payload
  },
  [STORE_JOIN_US] (state, payload) {
    state.join_us = payload
  }
}
